module.exports = __webpack_public_path__ + "static/img/5723_phase_function_Paper_PointsHejduk_Prediction.252ca34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5723_phase_function_Paper_PointsHejduk_Prediction.png
// module id = tlZc
// module chunks = 0